import React, { useState } from 'react';
import { SlidersHorizontal, ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Filters are always visible on ≥sm; on phones they collapse behind a "Filtros" toggle.
export const CollapsibleFilters = ({ active = false, children, testId = 'filters-toggle' }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-4">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid={testId}
        aria-expanded={open}
        className="sm:hidden mb-2 inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-slate-200 bg-white text-sm text-slate-700 active:bg-slate-50"
      >
        <SlidersHorizontal size={15} />
        {t('common.filters')}
        {active && <span className="h-2 w-2 rounded-full bg-emerald-500" data-testid={`${testId}-active`} />}
        <ChevronDown size={14} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <div className={`${open ? 'block' : 'hidden'} sm:block`}>{children}</div>
    </div>
  );
};

export default CollapsibleFilters;
